import React from 'react';
import { Container } from '../components/ui/Container';
export function PrivacyPage() {
  return <div className="bg-white py-20 lg:py-28" data-id="element-451">
      <Container size="md" data-id="element-452">
        <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl mb-8" data-id="element-453">
          Privacy Policy
        </h1>
        <p className="text-gray-500 mb-12" data-id="element-454">Last updated: January 1, 2025</p>

        <div className="prose prose-lg prose-indigo max-w-none" data-id="element-455">
          <p data-id="element-456">
            At Flowsense ("we", "us", or "our"), operated by Acciom Limited, we
            respect your privacy and are committed to protecting your personal
            data. This privacy policy will inform you as to how we look after
            your personal data when you visit our website and tell you about
            your privacy rights and how the law protects you.
          </p>

          <h2 data-id="element-457">1. Information We Collect</h2>
          <p data-id="element-458">
            We may collect, use, store and transfer different kinds of personal
            data about you which we have grouped together follows:
          </p>
          <ul data-id="element-459">
            <li data-id="element-460">
              <strong data-id="element-461">Identity Data</strong> includes first name, last name,
              username or similar identifier.
            </li>
            <li data-id="element-462">
              <strong data-id="element-463">Contact Data</strong> includes billing address, delivery
              address, email address and telephone numbers.
            </li>
            <li data-id="element-464">
              <strong data-id="element-465">Technical Data</strong> includes internet protocol (IP)
              address, your login data, browser type and version, time zone
              setting and location, browser plug-in types and versions,
              operating system and platform and other technology on the devices
              you use to access this website.
            </li>
            <li data-id="element-466">
              <strong data-id="element-467">Usage Data</strong> includes information about how you use
              our website, products and services.
            </li>
          </ul>

          <h2 data-id="element-468">2. How We Use Your Information</h2>
          <p data-id="element-469">
            We will only use your personal data when the law allows us to. Most
            commonly, we will use your personal data in the following
            circumstances:
          </p>
          <ul data-id="element-470">
            <li data-id="element-471">
              Where we need to perform the contract we are about to enter into
              or have entered into with you.
            </li>
            <li data-id="element-472">
              Where it is necessary for our legitimate interests (or those of a
              third party) and your interests and fundamental rights do not
              override those interests.
            </li>
            <li data-id="element-473">
              Where we need to comply with a legal or regulatory obligation.
            </li>
          </ul>

          <h2 data-id="element-474">3. Data Security</h2>
          <p data-id="element-475">
            We have put in place appropriate security measures to prevent your
            personal data from being accidentally lost, used or accessed in an
            unauthorized way, altered or disclosed. In addition, we limit access
            to your personal data to those employees, agents, contractors and
            other third parties who have a business need to know.
          </p>

          <h2 data-id="element-476">4. Data Retention</h2>
          <p data-id="element-477">
            We will only retain your personal data for as long as necessary to
            fulfill the purposes we collected it for, including for the purposes
            of satisfying any legal, accounting, or reporting requirements.
          </p>

          <h2 data-id="element-478">5. Your Legal Rights</h2>
          <p data-id="element-479">
            Under certain circumstances, you have rights under data protection
            laws in relation to your personal data, including the right to
            request access, correction, erasure, restriction, transfer, to
            object to processing, to portability of data and (where the lawful
            ground of processing is consent) to withdraw consent.
          </p>

          <h2 data-id="element-480">6. Contact Us</h2>
          <p data-id="element-481">
            If you have any questions about this privacy policy or our privacy
            practices, please contact us at:
          </p>
          <p data-id="element-482">
            Flowsense by Acciom Limited
            <br data-id="element-483" />
            Email: info@acciom.co.uk
          </p>
        </div>
      </Container>
    </div>;
}